<template>
    <div>
        <span :class="{'open':!isHomeworkEnd}">{{!isHomeworkEnd?'开放':'已关闭'}}</span>
    </div>
</template>

<style lang="scss" scoped>
.open {
    color: #185626;
}
</style>

<script>
export default {
    props: {
        data: {},
    },
    data() {
        return {
            isHomeworkEnd: false,
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.isHomeworkEnd = this.data.IsHomeworkEnd;
            }
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkCloseOrNotCell.vue